/**
 * Имена для упоминаний вида <@id>. Берём из кэша пользователей, а если там пусто —
 * из списка mentions самого сообщения: сервер кладёт туда всех упомянутых, и это работает
 * даже для тех, кого клиент никогда не видел. Без этого в тексте остаётся голый номер.
 */
import { displayName } from '@/store/social'
import type { Message, User } from '@/types/api'

export function mentionNames(message: Pick<Message, 'mentions' | 'author'> & { referenced_message?: Message | null }, users: Record<string, User> = {}) {
  return (id: string): string | undefined => {
    const known = users[id]
    if (known) return displayName(known)
    const found =
      message.mentions?.find((u) => u.id === id) ??
      message.referenced_message?.mentions?.find((u) => u.id === id) ??
      (message.author?.id === id ? message.author : undefined) ??
      (message.referenced_message?.author.id === id ? message.referenced_message.author : undefined)
    return found ? displayName(found) : undefined
  }
}
